import { FC } from "react";
import styled from "styled-components";

import constants from "../../_globalStyles/constants";
import LinkBase, { LinkBaseProps } from "../../atoms/LinkBase";
import Button, { ButtonProps } from "../../atoms/Button";

export const CreateAdControl: FC<ButtonProps> = styled(Button)`
  position: relative;
  z-index: 5;
`;

CreateAdControl.displayName = "CreateAdControl";

export const CreateAdLink: FC<LinkBaseProps> = styled(LinkBase)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  border-radius: ${constants.GRID_UNIT * 1.5}px;

  button:hover ~ &,
  button:active ~ &,
  a:hover ~ &,
  a:active ~ &,
  &:hover,
  &:active {
    box-shadow: 0 ${constants.GRID_UNIT / 2}px ${constants.GRID_UNIT * 3}px 0
      rgba(0, 0, 0, 0.1);
  }

  cursor: pointer;
  transition: box-shadow 0.05s ease-in;
`;

CreateAdLink.displayName = "CreateAdLink";
